/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ user_name: NonNullable<unknown>, user_account: NonNullable<unknown> }} Dialog_Subscription_Conflict_ContentInputs */

const en_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We found your subscription under ${i?.user_name} (${i?.user_account}). Please use this account to restore your Plus benefits.`)
};

const ar_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`وجدنا اشتراكك تحت ${i?.user_name} (${i?.user_account}). يرجى استخدام هذا الحساب لاستعادة مزايا Plus الخاصة بك.`)
};

const de_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wir haben Ihr Abonnement unter ${i?.user_name} (${i?.user_account}) gefunden. Bitte verwenden Sie dieses Konto, um Ihre Plus-Vorteile wiederherzustellen.`)
};

const es_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Encontramos su suscripción en ${i?.user_name} (${i?.user_account}). Utilice esta cuenta para restaurar sus beneficios Plus.`)
};

const fr_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nous avons trouvé votre abonnement sous ${i?.user_name} (${i?.user_account}). Veuillez utiliser ce compte pour restaurer vos avantages Plus.`)
};

const it_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abbiamo trovato il tuo abbonamento su ${i?.user_name} (${i?.user_account}). Utilizza questo account per ripristinare i tuoi vantaggi Plus.`)
};

const ja_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`お客様のサブスクリプションは ${i?.user_name} (${i?.user_account}) に紐付けられています。Plusの特典を復元するには、このアカウントを使用してください。`)
};

const ko_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.user_name} (${i?.user_account}) 계정에서 구독 정보를 찾았습니다. Plus 혜택을 복구하려면 이 계정을 사용해 주세요.`)
};

const pt_br_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Encontramos sua assinatura em ${i?.user_name} (${i?.user_account}). Use esta conta para restaurar seus benefícios Plus.`)
};

const ru_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Мы нашли вашу подписку в аккаунте ${i?.user_name} (${i?.user_account}). Пожалуйста, используйте этот аккаунт для восстановления преимуществ Plus.`)
};

const th_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เราพบการสมัครสมาชิกของคุณภายใต้ ${i?.user_name} (${i?.user_account}) โปรดใช้บัญชีนี้เพื่อกู้คืนสิทธิประโยชน์ Plus ของคุณ`)
};

const tr_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aboneliğinizi ${i?.user_name} (${i?.user_account}) hesabında bulduk. Plus avantajlarınızı geri yüklemek için lütfen bu hesabı kullanın.`)
};

const zh_cn_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你的 Plus 会员已绑定于${i?.user_name} (${i?.user_account})，切换该账号即可使用 Plus 会员权益。`)
};

const zh_tw_dialog_subscription_conflict_content = /** @type {(inputs: Dialog_Subscription_Conflict_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你的訂閱紀錄已綁定於${i?.user_name} (${i?.user_account})，切換該帳號即可使用訂閱權益。`)
};

/**
* | output |
* | --- |
* | "We found your subscription under {user_name} ({user_account}). Please use this account to restore your Plus benefits." |
*
* @param {Dialog_Subscription_Conflict_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_subscription_conflict_content = /** @type {((inputs: Dialog_Subscription_Conflict_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Subscription_Conflict_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_subscription_conflict_content(inputs)
	if (locale === "ar") return ar_dialog_subscription_conflict_content(inputs)
	if (locale === "de") return de_dialog_subscription_conflict_content(inputs)
	if (locale === "es") return es_dialog_subscription_conflict_content(inputs)
	if (locale === "fr") return fr_dialog_subscription_conflict_content(inputs)
	if (locale === "it") return it_dialog_subscription_conflict_content(inputs)
	if (locale === "ja") return ja_dialog_subscription_conflict_content(inputs)
	if (locale === "ko") return ko_dialog_subscription_conflict_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_subscription_conflict_content(inputs)
	if (locale === "ru") return ru_dialog_subscription_conflict_content(inputs)
	if (locale === "th") return th_dialog_subscription_conflict_content(inputs)
	if (locale === "tr") return tr_dialog_subscription_conflict_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_subscription_conflict_content(inputs)
	return zh_tw_dialog_subscription_conflict_content(inputs)
});